class CartGwp extends HTMLElement {
  connectedCallback() {
    this.giftVariantId = Number(window.gwpGiftVariantId);
    this.qualifyingQuantity = Number(window.gwpQualifyingQuantity) || 2;
    this.qualifyingProductIds = (window.gwpQualifyingProductIds || []).map(Number);
    this.unavailable = false;

    if (!this.giftVariantId || !this.qualifyingProductIds.length) return;

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-gwp') return;
      this.evaluateCart();
    });

    this.evaluateCart();
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  async evaluateCart() {
    if (this.pending) return;
    this.pending = true;

    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();

      const qualifyingQty = cart.items
        .filter((item) => this.qualifyingProductIds.includes(item.product_id))
        .reduce((sum, item) => sum + item.quantity, 0);

      const giftLineExists = cart.items.some((item) => item.variant_id === this.giftVariantId);

      if (qualifyingQty >= this.qualifyingQuantity && !giftLineExists && !this.unavailable) {
        await this.updateGiftCard(1);
      } else if (qualifyingQty < this.qualifyingQuantity && giftLineExists) {
        await this.updateGiftCard(0);
      }
    } catch (err) {
      console.error('[cart-gwp] evaluate error', err);
    } finally {
      this.pending = false;
    }
  }

  async updateGiftCard(quantity) {
    const cart = document.querySelector('cart-drawer');
    const config = fetchConfig('json');
    // /cart/change.js rejects a numeric id ("expected Integer to be a ... id"),
    // unlike /cart/add.js which accepts either — send it as a string for both.
    const body = { id: String(this.giftVariantId), quantity };

    if (cart) {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    config.body = JSON.stringify(body);

    const url = quantity > 0 ? routes.cart_add_url : routes.cart_change_url;
    const res = await fetch(url, config);
    const data = await res.json();

    if (data.status || data.errors) {
      console.error('[cart-gwp] update error', data.description || data.errors);
      // Shopify's Cart API is the only source of truth we have for a variant's
      // availability with just a raw ID (no product to check ahead of time), so
      // an add failure here is our availability signal. Stop retrying this
      // session rather than re-attempting on every subsequent cart change.
      if (quantity > 0) this.unavailable = true;
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gwp' });
    if (cart) cart.renderContents(data);
  }
}

if (!customElements.get('cart-gwp')) customElements.define('cart-gwp', CartGwp);
